module.exports = require('./helpers/bundle-url').getBundleURL('8gVFb') + "logo-dark.eefe0b7f.svg";